import angular from 'angular';
import userIngredientForm from './user-ingredient-form.component';

export default angular.module('components.admin.userIngredients.userIngredientForm', [])
  .component('userIngredientForm', userIngredientForm)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredient-form/user-ingredient-form.module.js